import React from 'react';
import Const from '../const/RTCC/Const';
class commonUtil extends React.Component {
    // チェックボックス表示リスト作成
    static getCheckList = (list, value, label, checked) => {
        let dataList = [];
        list.map((info) => {
            let obj = { value: info[value], label: info[label], checked: checked };
            dataList.push(obj);
        });
        return dataList;
    }
    // ラジオボタン表示リスト作成
    static getRadioList = (list, value, text, checked) => {
        let dataList = [];
        list.map((info) => {
            let obj = { value: info[value], text: info[text], checked: checked };
            dataList.push(obj);
        });
        return dataList;
    }
    // 文字列→日付変換
    static getDateFromString(target, separator) {
        let strDate = target.split(separator);
        return new Date(strDate[0], strDate[1] - 1, strDate[2])

    }
    // 日付→文字列変換(会員制、0埋め無し)
    static getStringFromDateMembership(target, format) {
        var year = target.getFullYear();
        var month = 1 + target.getMonth();
        var day = target.getDate();
        var hour = target.getHours();
        var minute = target.getMinutes();
        var second = target.getSeconds();

        format = format.replace(/yyyy/gi, year);
        format = format.replace(/MM/g, month);
        format = format.replace(/dd/gi, day);
        format = format.replace(/hh/gi, hour);
        format = format.replace(/mm/g, minute);
        format = format.replace(/ss/gi, second);

        return format;
    }
    // 日付→文字列変換（yyyy年MM月dd日（曜日））(会員制、0埋め無し)
    static getStringFromDateJpnMembership(target) {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(target);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${m}月${d}日（${youbi[checkInDate.getDay()]}）`;
    }
    // 日付→文字列変換
    static getStringFromDate(target, format) {
        var year = target.getFullYear();
        var month = 1 + target.getMonth();
        if (month < 10) {
            month = this.ZeroPadding(month, 2);
        }
        var day = target.getDate();
        if (day < 10) {
            day = this.ZeroPadding(day, 2);
        }
        var hour = target.getHours();
        if (hour < 10) {
            hour = this.ZeroPadding(hour, 2);
        }
        var minute = target.getMinutes();
        if (minute < 10) {
            minute = this.ZeroPadding(minute, 2);
        }
        var second = target.getSeconds();
        if (second < 10) {
            second = this.ZeroPadding(second, 2);
        }

        format = format.replace(/yyyy/gi, year);
        format = format.replace(/MM/g, month);
        format = format.replace(/dd/gi, day);
        format = format.replace(/hh/gi, hour);
        format = format.replace(/mm/g, minute);
        format = format.replace(/ss/gi, second);

        return format;
    }
    // 日付→文字列変換（yyyy年MM月dd日（曜日））
    static getStringFromDateJpn(target) {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(target);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${this.ZeroPadding(m, 2)}月${this.ZeroPadding(d, 2)}日（${youbi[checkInDate.getDay()]}）`;
    }
    // 日付→文字列変換（yyyy年MM月dd日（曜日））
    static getStringFromDateJpnGolf(target) {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(target);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`;
    }
    // 日付→文字列変換（MM/dd（曜日））
    static getStringFromDateJpnRtcc(target) {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const targetDate = new Date(target);
        const m = targetDate.getMonth() + 1;
        const d = targetDate.getDate();

        return `${m}/${d}(${youbi[targetDate.getDay()]})`;
    }
    // 0埋め桁数指定
    static ZeroPadding(target, digit) {
        target = String(target);
        while (target.length < digit) {
            target = "0" + target;
        }
        return target
    }
    // パスポート日付変換  
    // convFlg：変換方法 (true: パスポート表記 → "yyyy-MM-dd"表記, false: "yyyy-MM-dd"表記 → パスポート表記)
    static convPassportDate(target, convFlg) {
        let separator = convFlg ? " " : "-";
        let result = null;
        if (target != null) {
            result = convFlg ? "yyyy-MM-dd" : "dd MM yyyy";
            let dateList = target.split(separator);
            if (dateList.length != 3) {
                return false;
            }
            let year = "";
            let month = "";
            let day = "";

            let monthList = Const.ENG_MONTH_ABBR;
            if (convFlg) {
                year = dateList[2];
                month = dateList[1];
                day = dateList[0];
                let monthObj = monthList.find((value) => value.abbrName == month);
                if (!monthObj) {
                    return false;
                }
                month = monthObj.value;

            } else {
                year = dateList[0];
                month = dateList[1];
                day = dateList[2];
                let monthObj = monthList.find((value) => value.value == month);
                if (!monthObj) {
                    return false;
                }
                month = monthObj.abbrName
            }
            if (day.length != 2 || year.length != 4) {
                return false;
            }
            result = result.replace(/yyyy/gi, year)
            result = result.replace(/MM/g, month)
            result = result.replace(/dd/gi, day)

            if (convFlg) {
                let date = new Date(result)
                let checkDate = this.getStringFromDate(date, "yyyy-MM-dd");
                if (isNaN(date.getDate()) || result != checkDate) {
                    return false;
                }
            }
        }
        return result;
    }
    // プルダウン表示リスト作成
    static getSelectList = (list, value, option, blankFlg, headText) => {
        let dataList = [];
        if (blankFlg) {
            dataList.push({ id: "", value: headText });
        }
        list.map((info) => {
            let obj = { id: info[value], value: info[option] };
            dataList.push(obj);
        });
        return dataList;
    }
    // 料金順ソート
    static sortFee = (list, sort) => {
        if (sort == "dsc") {
            list.sort((first, second) => Math.max(...second.planList.map((value) => value.fee))
                - Math.max(...first.planList.map((value) => value.fee)));
            list.forEach(value => {
                value.planList.sort((first, second) => second.fee - first.fee);
            })
        } else {
            list.sort((first, second) => Math.min(...first.planList.map((value) => value.fee))
                - Math.min(...second.planList.map((value) => value.fee)));
            list.forEach(value => {
                value.planList.sort((first, second) => first.fee - second.fee);
            })
        }
        return list;
    }
    // ルートドメインの取得
    static getDomain = () => {
        let domain = window.location.origin;
        return domain;
    }
    // 特殊文字の置換
    static replaceSpecialChar = (target) => {
        return target.replaceAll("\&quot\;", "\"").replaceAll("\&lt\;", "\<").replaceAll("\&gt\;", "\>").replaceAll("\&nbsp\;", " ").replaceAll("\&\#9314\;", "③").replaceAll("\<br\>", "\n").replaceAll("\<br /\>", "\n").replaceAll("\&middot\;", "・");
    }
    // 改行コード変換
    static replaceNewLineChar = (target) => {
        return target.replaceAll("\&quot\;", "\"").replaceAll("\&nbsp\;", " ").replaceAll("\\n", "\<br\>");
    }
    // 日付リスト作成
    // 開始日と終了日を引数に、その期間の日付のリストを作成する(yyyy-MM-dd)
    static getDateList = (start, end, format) => {
        let startDate = new Date(start);
        let endDate = new Date(end);
        endDate = endDate.setDate(endDate.getDate() + 1)
        let result = [];
        for (let date = startDate; date < endDate; date.setDate(date.getDate() + 1)) {
            result.push(this.getStringFromDate(date, format))
        }
        return result;
    }
    // 開始日と終了日を引数に、その期間の宿泊日付のリストを作成する(yyyy-MM-dd)
    static getHakuDateList = (start, end, format) => {
        let startDate = new Date(start);
        let endDate = new Date(end);
        let result = [];
        for (let date = startDate; date < endDate; date.setDate(date.getDate() + 1)) {
            result.push(this.getStringFromDate(date, format))
        }
        return result;
    }
    // 泊数計算
    static getNights = (checkInStr, checkOutStr, separator) => {
        let checkInDate = this.getDateFromString(checkInStr, separator);
        let checkOutDate = this.getDateFromString(checkOutStr, separator);
        let nights = (checkOutDate - checkInDate) / 86400000;
        return nights;
    }
    // 選択人数リスト作成
    static getPeopleNumList = (min, max, selected) => {
        const list = [];
        for (let i = min; i <= max; i++) {
            if (i == selected) {
                list.push({ id: i + "", value: i + "人", selected: true });
            } else {
                list.push({ id: i + "", value: i + "人", selected: false });
            }
        }
        return list;
    }
    // 時間表示変換(hhmm表記のデータを任意のフォーマットで変換)
    static getTimeStr = (time, format) => {
        if (time.length == 4) {
            let hour = time.slice(0, 2);
            let minute = time.slice(2);
            format = format.replace(/hh/gi, hour);
            format = format.replace(/mm/g, minute);
            return format.replace(/^0+/, '');   
        } else {
            return time;
        }
    }
    // チェックイン日とチェックアウト日が開業日を跨いでいるかのチェック
    static checkOpeningDate = (start, end, target) => {
        let startDate = new Date(start);
        let endDate = new Date(end);
        let targetDate = new Date(target);
        return startDate < targetDate && targetDate < endDate;
    }
    // 予約入力/入力内容確認画面不正アクセスチェック
    static checkIllegalAccess = (reserveInfo, searchParam) => {
        if (Object.keys(reserveInfo).length == 0 || Object.keys(searchParam).length == 0) {
            return true;
        }
        if (!reserveInfo.shisetsuName) {
            return true;
        }
        if (!searchParam.checkInDate) {
            return true;
        }
        if (!searchParam.checkOutDate) {
            return true;
        }
        if (!searchParam.nights) {
            return true;
        }
        if (!searchParam.roomCnt) {
            return true;
        }
        return false;
    }
}
export default commonUtil